import { Button } from '@/components/form/baseInputs/Button';
import { Download01Icon } from '@/components/icons/Download01Icon';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import { $downloadStreamedFile } from '@/modules/files/utils/fileUtils';

import { useDownloadLiabilitiesExportV2Mutation } from './graphql/DownloadLiabilitiesCSVButton.generated';

export interface DownloadLiabilitiesCSVButtonProps {
  householdId: string;
  disabled?: boolean;
}

export function DownloadLiabilitiesCSVButton({
  householdId,
  disabled = false,
}: DownloadLiabilitiesCSVButtonProps) {
  const { showFeedback } = useFeedback();
  const trackUserEvent = useTrackUserEvent();
  const { createErrorFeedback } = useFeedback();

  const [generateCSV, { loading }] = useDownloadLiabilitiesExportV2Mutation({
    variables: {
      householdId,
    },
    onError: createErrorFeedback('Failed to download CSV export'),
    onCompleted: async (data) => {
      const token = data.exportLiabilityReportV2.token;
      try {
        await $downloadStreamedFile(`/api/download/file?token=${token}`);
        trackUserEvent('liability exported', {
          householdId,
        });
      } catch (err) {
        showFeedback('Failed to download CSV. Please try again.');
      }
    },
  });

  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={() => generateCSV()}
      startIcon={Download01Icon}
      loading={loading}
      disabled={disabled}
    >
      Export CSV
    </Button>
  );
}
